import { UserSettingsDTO } from '../api';

export interface ISettings {
    contactEmail?: string;
    dateRegistered?: Date;
    nickname?: string;
    name?: string;
    surname?: string;
    emailVerified?: boolean;
    canChangePassword?: boolean;
    picture?: string;
    config?: UserSettingsDTO;
}

export class SettingsService {
    public static instance: SettingsService;
    public static settingsConst = 'settings';

    public static getInstance() {
        if (SettingsService.instance == undefined) {
            SettingsService.instance = new SettingsService();
        }

        return SettingsService.instance;
    }

    public getSettings(): ISettings | null {
        const temp = localStorage.getItem(SettingsService.settingsConst);
        if (temp != undefined) {
            // tslint:disable-next-line:no-console
            const settings = JSON.parse(temp) as ISettings;
            return settings;
        }

        return null;
    }

    public nameIsIncomplete(): boolean {
        const settings = this.getSettings();
        if (!settings) {
            return false;
        }

        if (settings.name == undefined || settings.surname == undefined) {
            return true;
        }

        return false;
    }

    public emailIsVerified(): boolean {
        const settings = this.getSettings();
        if (!settings) {
            return true;
        }

        if (settings.emailVerified == undefined || !settings.emailVerified) {
            return false;
        }

        return true;
    }

    public getNameOrEmail(): string {
        const settings = this.getSettings();
        if (settings == undefined) {
            return '';
        }

        if (settings.name != undefined && settings.surname != undefined) {
            return `${settings.name} ${settings.surname}`;
        } else if (settings.contactEmail) {
            return settings.contactEmail;
        }

        return '';
    }

    public setSettings(settings: ISettings) {
        localStorage.setItem(
            SettingsService.settingsConst,
            JSON.stringify(settings)
        );
    }

    private constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/SettingsService.ts